import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Bell } from '@phosphor-icons/react';
import { InsightAlert } from '../../design-system/components';

export default function InsightAlerts({ alerts }) {
  const list = Array.isArray(alerts) ? alerts : [];

  return (
    <div className="rounded-xl border border-[var(--line)] bg-[var(--surface-card)] p-5 shadow-sm" data-testid="insight-alerts-section">
      <div className="flex items-center gap-2 border-b border-[var(--line)] pb-3">
        <Bell size={16} className="text-slate-700" aria-hidden />
        <h3 className="font-heading text-sm font-bold text-slate-900">
          Insights & Alerts
        </h3>
        {list.length > 0 && (
          <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold text-amber-800">
            {list.length}
          </span>
        )}
      </div>

      <div className="mt-4 space-y-3">
        {list.length > 0 ? (
          list.map((alert) => (
            <InsightAlert
              key={alert.alertId}
              tone={alert.category === 'risk' ? 'critical' : (alert.category === 'decision_overdue' ? 'warn' : 'info')}
              title={alert.title}
              description={alert.detail}
              action={
                alert.actionTarget ? (
                  <Link
                    to={alert.actionTarget}
                    className="inline-flex items-center gap-1 rounded px-2 py-1 text-[11px] font-semibold hover:underline"
                    aria-label={alert.actionLabel}
                  >
                    {alert.actionLabel}
                  </Link>
                ) : null
              }
              testId={`alert-${alert.alertId}`}
            />
          ))
        ) : (
          <div className="flex items-center gap-3 rounded-lg border border-emerald-100 bg-emerald-50/50 p-4 text-emerald-900">
            <CheckCircle size={20} className="shrink-0 text-emerald-600" aria-hidden />
            <div>
              <p className="text-xs font-semibold text-emerald-950">
                No current overview alerts
              </p>
              <p className="text-[11px] text-emerald-700">
                All authoritative signals and decision gates are operating within normal tolerances.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

